<template>
  <div id="manage">
    <div class="content">
        <div class="title">课件制作</div>
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <div class="fl_right addClass" @click="addRecruit">新增课程</div>
                </div>
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                    <Table :columns="columns7" :data="data6" :loading="loading"></Table>
                </div>
                <Page :page-size="pageSize" :total="total" show-total :current="pageNum" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page>
            </div>
            <div class="alertBox" v-if="alertShow">
                <div class="tanchuan">
                    <div class="tantop">
                        <div class="fl_left tantitle">{{valm==1?'编辑':'新增'}}</div>
                        <div class="fl_right tandel" @click="tandel"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="tancenter">
                        <div class="list listpad">
                            <div class="fl_left name">课程名称<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                            <div class="fl_left inputBox">
                                <Input v-model="canpany_name" class="bordiv" size="large" autocomplete="off" style="width:440px;" placeholder="请输入课程名称" />
                                <input type="text"  autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">课程介绍<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                            <div class="fl_left inputBox">
                                <Input v-model="address" class="bordiv" size="large" style="width:440px;" placeholder="课程介绍" />
                                <input type="text" autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">课程图片<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                            <div class="fl_left inputBox">
                                <div class="file-list">
                                    <!-- <section class="file-item draggable-item" v-if="logo">
                                        <img :src="logo" alt="" ondragstart="return false;" >
                                    </section>
                                    <section v-else class="file-item>
                                        <div class="add"></div>
                                    </section> -->
                                    <div class="urlLogo urlLogo1" >
                                        <img :src="imgd1" alt="">
                                        <div class="add" v-if="!imgd1"></div>
                                        <!-- <img src="static/imgs/up_zjz.png" alt="" v-if="!imgd1"> -->
                                        <input type="file" id="file1" multiple="false" @change="doUpload(1)"/>
                                    </div>
                                </div>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <div class="tanBtn" @click="tanyes(valm)">确定</div>
                </div>
            </div>
            <div class="alertBox" v-show="cropShow" style="padding-top: 8%">
                <div style="background: #fff;width: 600px;height: 445px;margin:0 auto;
                padding-top: 20px;">
                    <div class="cropper">
                        <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :info="true"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :autoCropWidth="option.autoCropWidth"
                        :autoCropHeight="option.autoCropHeight"
                        :fixedBox="option.fixedBox"
                        >
                        </vueCropper>
                    </div>
                    <div style="width: 300px;margin: 0 auto;">
                        <div class="fl_left tanBtn tanBtned tanBtneds" @click="delCrop">取消</div>
                        <div class="fl_right tanBtn tanBtneds" @click="upload('base64')">确认裁剪</div>
                        <div class="clear"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'manage',
        data () {
            return {
                canpany_name:'',
                address:'',
                total:null,
                pageNum:1,
                pageSize:10,
                loading:false,
                UPload:false,
                cropShow:false,
                option: {
                    img: '',//剪切图片地址
                    size: 1,//输出图片压缩比默认为1
                    full: false,//输出截图是否缩放
                    outputType: 'jpg',//输出图片格式
                    canMove: true,//是否可以拖动图片
                    fixedBox: true,//是否固定截图大小
                    original: false,//上传图片按原始比例
                    canMoveBox: false,//是否可以拖动截图框
                    autoCrop: true,//是否自成截图框
                    // 只有自动截图开启 宽度高度才生效
                    autoCropWidth: 484,//截图框宽
                    autoCropHeight: 308,//截图框高
                    centerBox: false,//截图框能否超过图片
                    high: true//是否根据dpr输出高清图片
                },
                columns7: [
                    {
                        title: '#',
                        type: 'index',
                        align: 'center',
                        width:80
                    },
                    {
                        title: '课程图片',
                        align: 'center',
                        key: 'title',
                        render: (h, params) => {
                            return h('img',{
                                            style:{
                                                width:'150px',
                                            },
                                            domProps: {
                                                src:params.row.cover
                                            }
                                        })
                        }
                    },
                    {
                        title: '课程名称',
                        align: 'center',
                        key: 'name',
                    },
                    {
                        title: '包含的期数',
                        align: 'center',
                        key: 'issue_num',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div',params.row.issue_num+'期');
                            // }
                        }
                    },
                    {
                        title: '课程介绍',
                        align: 'center',
                        key: 'introduce',
                        width:200,
                        render: (h, params) => {
                            return h('div',{}, 
                            [
                                h('Tooltip', 
                                    {
                                      props: {
                                        placement: 'bottom',
                                        transfer: true
                                      }
                                    },
                                    [
                                        h('div',{
                                            style:{
                                                cursor:'pointer',
                                                color:'#409eff',
                                                display:'block',
                                                overflow:'hidden',
                                                textOverflow:'ellipsis',
                                                whiteSpace: 'nowrap',
                                                wordBreak:'break-all',
                                                height:'20px',
                                                width:'200px',
                                            }
                                        },params.row.introduce),
                                        h('span',{
                                          slot:'content',
                                          style:{
                                            whiteSpace:'normal'
                                          }
                                        },params.row.introduce)
                                    ]
                                )
                            ])
                            // return h('div', [
                            //     h('button', {
                            //         props: {
                            //             type: 'primary',
                            //             size: 'small',
                            //         },
                            //         style: {
                            //             backgroundColor:'rgba(0,0,0,0)',
                            //             border:'none',
                            //             marginLeft:'10px'
                            //         },
                            //         on: {
                            //             click: () => {
                            //                 let _this=this;
                                            
                            //                 this.$Notice.info({
                            //                     title: '课程介绍',
                            //                     desc: params.row.introduce,
                            //                     duration:0,
                            //                 });
                            //             }
                            //         }
                            //     }, '查看'),
                            // ]);
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'bespeak_count',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    h('div',[
                                        h('button',{
                                            props: {
                                                type: 'primary',
                                                size: 'small',
                                            },
                                            style: {
                                                backgroundColor:'rgba(0,0,0,0)',
                                                border:'none',
                                                marginBottom:'10px',
                                            },
                                            on: {
                                                click: () => {
                                                    let luder = {
                                                        "pageNum": this.pageNum,
                                                        "cate_id":params.row.id,
                                                        "name":params.row.name,
                                                    };
                                                    luder = JSON.stringify(luder);
                                                    localStorage.setItem("luder", luder);
                                                    this.$router.push({
                                                        path:'/manager/stu_class/class/singleLesson',
                                                        query:{
                                                            cate_id:params.row.id,
                                                            name:params.row.name,
                                                        }
                                                    })
                                                }
                                            }
                                        }, '开始制作')
                                    ]),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                _this.canpany_name=params.row.name;
                                                _this.address=params.row.introduce;
                                                _this.file_url1=params.row.cover;
                                                _this.imgd1=params.row.cover;
                                                _this.cate_id=params.row.id;
                                                _this.valm=1;
                                                _this.alertShow=true;
                                            }
                                        }
                                    }, '编辑'),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                            marginLeft:'10px'
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要删除？</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('deletecategory',{cate_id:params.row.id}).then(res=>{
                                                            if(res.data.code==200){
                                                                _this.$Message.success('删除成功');
                                                                _this.search(0);
                                                             }
                                                             else{
                                                                 this.$Message.error(res.data.message);
                                                             }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, '删除'),
                                ]);
                            // }
                        }
                    }
                ],
                data6: [],
                alertShow:false,
                valm:0,
                clnum:1,
                imgd1:'',
                file_url1:'',
                cate_id:'',
            }
        },
        methods:{
            //点击上传图片事件
            doUpload(index){
                let _this = this;
                _this.clnum=index;
                if(index==1){
                    var files = document.getElementById('file1');
                    var fileLen = document.getElementById('file1').files;
                    var filename=$('#file1').val();
                    // _this.uploadByOss(fileLen[0])
                    // _this.option.autoCropWidth=241;//截图框宽
                    // _this.option.autoCropHeight=337;//截图框高
                    _this.option.img=URL.createObjectURL(fileLen[0]);
                    _this.cropShow=true;
                    // _this.imgd1=URL.createObjectURL(fileLen[0]);
                    $('#file1').val('')
                }
            },
            //图片地址
            upload(type){
                let _this=this;
                _this.$refs.cropper.getCropData((dataURL) => {
                    let base64 = dataURL.split(',')[1];
                    let fileType = dataURL.split(';')[0].split(':')[1];
                    let blob = this.toBlob(base64,fileType);
                    let reader = new FileReader();
                    reader.readAsArrayBuffer(blob);
                    reader.onload = function (event) {
                        var file = new File([blob],new Date().getTime()+'.'+blob.type.split('/')[1],{type: "image/png"})
                        _this.uploadByOss(file)
                        if(_this.clnum==1){
                            _this.imgd1=dataURL;
                        }
                    }

                })
            },
            //裁剪弹窗隐藏
            delCrop(){
                this.cropShow=false;
            },
            //二进制转换
            toBlob(urlData,fileType){
                var bytes=window.atob(urlData),
                    n=bytes.length,
                    u8arr=new Uint8Array(n);
                while(n--){
                    u8arr[n]=bytes.charCodeAt(n);
                }
                return new Blob([u8arr],{type:fileType});
            },
            random_string(len) {
                len = len || 32;
                var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
                var maxPos = chars.length;
                var pwd = "";
                for (var i = 0; i < len; i++) {
                    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                } 
                return pwd;
            },
            //阿里云上传
            uploadByOss(file){
                let _this = this;
                const loading = this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var fileurl =new Date().getTime() + _this.random_string(16)+'.'+file.name.split('.')[1]
                return new Promise(function(resolve , reject){  // Promise 一定要在函数的最外层才有效
                    _this.$axios.post('policyaction').then(function(res){
                         var re = res.data.data;
                         var osssignature = {
                            'key' : re.dir+fileurl,
                            'policy': re.policy,
                            'OSSAccessKeyId': re.accessid,
                            'success_action_status' : '200', 
                            'signature': re.signature,
                            'callback':re.callback,
                        };
                        var formData = new FormData()
                        for( var k in osssignature ){
                            formData.append(k, osssignature[k])
                        }
                        //var suffix = _this.get_suffix(file.type); // 获取文件扩展名
                        formData.append("key", re.dir);
                        formData.append('file', file)  // 必须放最后
                        var xhr = new XMLHttpRequest()
                        //xhr.upload.addEventListener('progress', uploadProgress, false)
                        xhr.open('POST', re.host, true)
                        xhr.send(formData)
                        xhr.onload = () => {
                            if (xhr.status === 200 || xhr.status === 304) {
                                loading.close();
                                if(_this.clnum == 1){
                                    _this.file_url1 = xhr.responseURL + re.dir + fileurl;
                                    _this.cropShow=false;
                                }
                            } else {
                                console.log(`error：error code ${xhr.status}`)
                            }
                        }             
                    })
                })
            },            
            //确定提交
            tanyes(index){
                let _this=this;
                let pattern=/^1[3456789]\d{9}$/;//手机号验证
                let patternemail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(_this.canpany_name==''){
                    this.$Message.error('请输入课程名称');
                }
                else if(_this.address==''){
                    this.$Message.error('请输入课程介绍');
                }
                else if(_this.lxname==''){
                    this.$Message.error('请添加项目图片');
                }
                else{
                    if(index==0){
                        _this.$axios.post('addcategory',{
                            name:_this.canpany_name,
                            introduce:_this.address,
                            cover:_this.file_url1,
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.alertShow=false;
                                _this.search(0);
                            }
                            else{
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                          console.log(error);
                        });
                    }
                    if(index==1){
                        _this.$axios.post('editcategory',{
                            name:_this.canpany_name,
                            introduce:_this.address,
                            cover:_this.file_url1,
                            cate_id:_this.cate_id,
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.alertShow=false;
                                _this.search(0);
                            }
                            else{
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                          console.log(error);
                        });
                    }
                }
            },
            tandel(){
                this.alertShow=false;
            },
            tab(index,item){
                let _this=this;
                _this.num=index;
                _this.tabId=item.type;
                _this.canpay_name='';
                _this.getscity();
            },
            search(index){
                let _this=this;
                if(index==1){
                    _this.pageNum=1;
                }
                _this.$axios.post('getcategorylist',{
                    page:_this.pageNum,
                    page_size:_this.pageSize
                }).then(res=>{
                    if(res.data.code==200){
                        _this.total=res.data.data.total;
                        _this.data6=res.data.data.list;
                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            updatePage(num) {
                this.pageNum = num;
                this.search(0);
            },
            addRecruit(){
                let _this=this;
                _this.valm=0;
                _this.canpany_name='';;
                _this.address='';
                _this.imgd1='';
                _this.file_url1='';
                _this.alertShow=true;
            },
        },
        created(){
            let _this=this; 
            let luder=JSON.parse(localStorage.getItem("luder"));
            if(luder!=null){
                _this.pageNum=luder.pageNum;
                _this.search(0)
            }
            else{
                _this.search(1);
            }
        }
    }
</script>

<style scoped>
/**/
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
/**/
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 116px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 58px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e6e6e6;
        padding: 0 20px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
    .add {
        width: 200px;
        height: 136px;
        float: left;
        cursor: pointer;
        background: url(../../../static/imgs/upload.jpg) no-repeat;  /*// 这里使用的是我本地图片*/
        background-size: 100% 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/stu_class/class.vue